/** Largest valid `scrollLeft`/`scrollTop` for a scroller (never negative). */
export function getMaxScrollOffsets(scroller: HTMLElement): { maxLeft: number; maxTop: number } {
  const maxLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth)
  const maxTop = Math.max(0, scroller.scrollHeight - scroller.clientHeight)

  return { maxLeft, maxTop }
}

/** Write `left`/`top` to the scroller, each clamped to its scroll range. */
export function clampScrollerToRange(scroller: HTMLElement, left: number, top: number): void {
  const { maxLeft, maxTop } = getMaxScrollOffsets(scroller)

  scroller.scrollLeft = Math.max(0, Math.min(maxLeft, left))
  scroller.scrollTop = Math.max(0, Math.min(maxTop, top))
}
